import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import styled, { css } from "styled-components";

import { ordersActions } from "_store/actions";

import GeneralInfo from "components/OrderDetail/GeneralInfo";
import Assessment from "components/OrderDetail/Assessment";
import { ErrorModal } from "components/Modals/ErrorModal";
import { SpinnerWrapper } from "widget/Spinner";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 600px;

  animation: 0.2s linear fadeIn;
  @keyframes fadeIn {
    from {
      opacity: 0%;
    }
    to {
      opacity: 100%;
    }
  }
`;
const Title = styled.h2`
  margin-bottom: 14px;
  font-weight: bold;
  font-size: 24px;
  line-height: 47px;
  color: #03589c;

  ${({ theme: { mobile } }) =>
    mobile &&
    css`
      margin-left: 0px;
    `}
`;
const Column = styled.div`
  max-width: 1364px;
  width: 100%;
  ${({ theme: { mobile } }) =>
    mobile &&
    css`
      padding: 0 20px;
    `}
`;
const Button = styled.button`
  width: 209px;
  height: 42px;
  margin-bottom: 24px;
  background: #f37217;
  border: none;
  border-radius: 4px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  color: #fafaff;
`;

export default function AssessmentReportPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { orderDetails, error, orderDetailsLoading } = useSelector(({ orders }) => orders);

  const { orderId } = useParams();

  useEffect(() => {
    dispatch(ordersActions.getOrder(orderId));
  }, [orderId, dispatch]);

  if (!orderDetails)
    return <Container>{(orderDetailsLoading && <SpinnerWrapper />) || (error && <ErrorModal />)}</Container>;

  const assessmentDetails = orderDetails?.products.find(({ code: { code } }) =>
    ["TRADEMARK_Legal_Team_Trademark_Assessment"].includes(code)
  );

  const isReady = assessmentDetails?.processingResult?.status === "Completed";

  if (!assessmentDetails || !isReady) {
    navigate(`/orders/${orderId}`);

    return null;
  }

  const assessments = {
    trademarkAssessment: {
      name: "trademarkAssessment",
      value: assessmentDetails?.trademarkAssessment || false,
      description: assessmentDetails?.trademarkAssessmentDescription || "",
    },
    competitiveAnalysis: {
      name: "competitiveAnalysis",
      value: assessmentDetails?.competitiveAnalysis || false,
      description: assessmentDetails?.competitiveAnalysisDescription || "",
    },
    strategicGuidance: {
      name: "strategicGuidance",
      value: assessmentDetails?.strategicGuidance || false,
      description: assessmentDetails?.strategicGuidanceDescription || "",
    },
  };

  return (
    <Container>
      <GeneralInfo orderDetails={orderDetails} />
      <Title>Legal Team Trademark Assessment Report</Title>
      <Column>
        <Assessment assessments={assessments} />
      </Column>
      <Button onClick={() => navigate(`/orders/${orderId}`)}>Go Back</Button>
    </Container>
  );
}
